import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Users, Compass, MessageCircle, DollarSign, Flag } from 'lucide-react';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const navItems = [
    { path: '/social', icon: Users, label: 'Social' },
    { path: '/discover', icon: Compass, label: 'Discover' },
    { path: '/messages', icon: MessageCircle, label: 'Messages' },
    { path: '/scores', icon: Flag, label: 'Scores' },
    { path: '/betting', icon: DollarSign, label: 'Games' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur-xl"
      data-testid="bottom-navigation"
    >
      <div className="max-w-lg mx-auto px-2">
        <div className="flex items-center justify-around py-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path ||
              (item.path === '/messages' && location.pathname.startsWith('/messages')) ||
              (item.path === '/discover' && location.pathname.startsWith('/user/')) ||
              (item.path === '/betting' && location.pathname.startsWith('/betting'));
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-all duration-200 ${isActive ? 'text-primary' : 'text-muted-foreground'}`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <div className={`p-1 rounded-lg transition-all ${isActive ? 'bg-primary/10' : ''}`}>
                  <item.icon className="w-5 h-5" />
                </div>
                <span className="text-[10px] font-semibold">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
